var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5,
    r: 16,
    fill: "#0E8750"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7016 10.7165C24.0686 11.031 24.1016 11.5728 23.7755 11.9266L14.294 22.2123C14.1253 22.3953 13.8835 22.5 13.6296 22.5C13.3757 22.5 13.134 22.3953 12.9653 22.2123L8.22453 17.0695C7.89839 16.7156 7.93143 16.1739 8.29835 15.8594C8.66527 15.5449 9.22711 15.5767 9.55326 15.9306L13.6296 20.3527L22.4467 10.7877C22.7729 10.4339 23.3347 10.402 23.7016 10.7165Z",
    fill: "#F8F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepChecked);
export default __webpack_public_path__ + "static/media/StepChecked.3c1994e8648b765a6fcb946bacaedecd.svg";
export { ForwardRef as ReactComponent };